<template>
  <WsRead
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    orderBy="sequence"
    orderWay="asc"
    titleKey="locales.name"
  >
  </WsRead>
</template>

<script>
import model from "@/models/system_class";
import submodel from "@/models/system_subclass";
export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      localeMode: true,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: "infoCard",
            hideOnNull: false,
            floors: [
              {
                fields: ["locales", "area"],
              },
            ],
          },
          {
            type: "expandList",
            label: submodel.label,
            modelName: submodel.modelName,
            modeParent: true,
            fields: submodel.fields,
            titleKey: "name",
            fieldsRead: submodel.fieldsRead,
            searchMode: false,
            hideOnNull: false,
            getUrl: () => {
              return `/${submodel.modelName}`;
            },
            extendParams: () => ({system_class: this.$route.params.id}),
          },
        ],
        secondary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "設定",
                fields: ["sequence"],
              },
            ],
          },
        ],
      },
    }
  },
}
</script>